/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import config from '../config/featuresSection.config.json';
import { useProvinance } from '../provider';

export interface IFeatureSectionMethods extends IPluginMethodMap {
  getFeatureSectionProps(args: any): Promise<any>;
}

export class FeatureSectionService implements IAgentPlugin {
  readonly methods: IFeatureSectionMethods;

  constructor() {
    this.methods = {
      getFeatureSectionProps: this.getProps.bind(this),
    };
  }

  async getProps(args: any) {
    const { provId } = useProvinance();
    return {
      productData: {
        ...(config[provId] || {}),
        badgeCarouselItems: this.getBadgeCarousel(
          config[provId]?.batchCredentials
        ),
      },
    };
  }

  private getBadgeCarousel(data: any) {
    let _temp: any = [];
    Array.isArray(data) &&
      data.forEach((element) => {
        _temp.push({
          batchData: element,
          key: element?.batchId,
          titleImage: element?.logo,
          title: element?.name,
        });
      });

    return _temp;
  }
}
